import req from './http.js'

// 店家掃描QR Code檢查核銷碼
export const apiCheckTicketNo = params => req('post', '/reservation/work_site/check_ticket_no', params)

// 店家確認核銷
export const apiConfirmAttendance = params => req('post', '/reservation/work_site/confirm_attendance', params)

// 手動輸入核銷碼核銷票券
export const apiManualInputTicketNo = params => req('post', '/reservation/work_site/manual_input_ticket_no', params)